enum CheckoutModeEnum {
    NONE = 0,
    CREDIT_ACCOUNT = 1 << 0,
    BUY_ASSET = 1 << 1,
    MULTIPLE_BUY_ASSET = 1 << 2,
    BUY_BOOST_SCORE = 1 << 3,
    BUY_TOURNAMENT_TICKET = 1 << 4,
}

export default CheckoutModeEnum;